import { Action, OperationType } from "puzzle";

export const reloadCreateSubmission: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'userPromise',
  type: OperationType.action
}, {
  name: 'getProjectForSubmission',
  type: OperationType.action
}, {
  name: 'getSubmissionMode',
  type: OperationType.action
}, {
  name: 'isClaimScopeActive',
  type: OperationType.action
}, {
  type: OperationType.conditional,
  condition: '{submissionMode} !== "TEMPLATE_CREATE"',
  conditionOperations: [{
    name: 'getTemplatesForSubmission',
    type: OperationType.action
  }]
}, {
  condition: '{submissionProjects.length === 1}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          projectId: '{submissionProjects[0].projectId}'
        }
      }
    },
    name: 'getDataByProject',
    type: OperationType.action
  }, {
    name: 'getProjectPolicies',
    type: OperationType.action
  }, {
    name: 'preselectSubmissionData',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  moduleName: 'View',
  name: 'takeSubmissionSnapshot'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const preselectSubmissionData: Action = [{
  moduleName: 'Details',
  args: ['projectId'],
  name: 'preselectProject'
}, {
  data: {
    template: {
      bind: {
        userName: '{initializeUserData.userProfile.userInfo.userName}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'Details',
  name: 'selectLoggedProjectManager',
  args: ['userName']
}, {
  moduleName: 'Details',
  args: ['projectId'],
  name: 'getDefaultWorkflow',
  mappingName: 'defaultWorkflowId',
  type: OperationType.addOperationData
}, {
  condition: '!_.get({initializeUserData}, "applicationInfo.tptEnabled")',
  conditionOperations: [{
    moduleName: 'Details',
    name: 'preselectSourceLanguage'
  }, {
    moduleName: 'Details',
    name: 'preselectTargetLanguage'
  }, {
    moduleName: 'Details',
    name: 'getDefaultTargetLanguagesData',
    mappingName: 'defaultTargetLanguages',
    type: OperationType.addOperationData
  }, {
    condition: '{defaultTargetLanguages.length}',
    conditionOperations: [{
      moduleName: 'DropUpload',
      moduleId: 'fromInstructions',
      name: 'setTargetLanguages',
      args: ['defaultTargetLanguages']
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  moduleName: 'Details',
  name: 'setWorkflowData',
  args: ['workflows', 'defaultWorkflowId']
}, {
  name: 'enableUpload',
  args: ['projectId'],
  type: OperationType.action
}];
